// Visuels générés (mockups premium) + astuces éditoriales par module.
const B = "https://static.prod-images.emergentagent.com/jobs/f66e0e14-b56e-4de5-b0fd-8ad35555866a/images/";

export const MODULE_IMAGES = {
  punch: "/punch-punch-mobile.webp",
  crm: "/crm-dashboard.webp",
  erp: B + "8329f92e449eaa4d6c21df1492ffa58914bfab54deaac4c96f3f6b954be4d991.png",
  compta: B + "33ce09b9e090bfeb4ed1197b267841dd4dfc2b2b26c5f6f888b4adc3d5874b9b.png",
  "devis-ai": B + "9e74018e1d448392ddd06473af84e7d27fc67ea679ed7bb4a4475882d1710699.png",
};

export const ADVISOR_IMAGE = B + "e4895d16830ca23087e16e54214462d60996383507f6655b3412148b785e160c.png";

export const MODULE_TIPS = {
  punch: {
    fr: [
      "Activez le géofence par chantier : le punch se valide automatiquement quand l'employé arrive sur le site.",
      "Les feuilles de temps se génèrent seules — exportez-les vers la paie en un clic, formats CCQ inclus.",
      "Utilisez les approbations multi-niveaux pour que chaque contremaître valide ses équipes.",
    ],
    en: [
      "Enable per-site geofencing: punches validate automatically when an employee reaches the job site.",
      "Timesheets generate themselves — export them to payroll in one click, CCQ formats included.",
      "Use multi-level approvals so each foreman validates their own crews.",
    ],
  },
  crm: {
    fr: [
      "Reliez chaque soumission à un client : vous voyez d'un coup d'œil le taux de conversion par vendeur.",
      "Programmez des relances automatiques — aucune opportunité ne tombe entre les mailles.",
      "Segmentez vos clients (résidentiel, commercial, sous-traitants) pour des campagnes ciblées.",
    ],
    en: [
      "Link every quote to a client: instantly see conversion rate per salesperson.",
      "Schedule automatic follow-ups — no opportunity slips through the cracks.",
      "Segment clients (residential, commercial, subcontractors) for targeted campaigns.",
    ],
  },
  erp: {
    fr: [
      "Planifiez vos phases en Gantt et détectez les chevauchements de ressources avant qu'ils coûtent cher.",
      "Ajoutez TAKE OFF pour mesurer vos quantités directement sur les plans PDF.",
      "Suivez les budgets par projet en temps réel : bons de commande, dépenses et marges au même endroit.",
    ],
    en: [
      "Plan phases with Gantt and spot resource conflicts before they get costly.",
      "Add TAKE OFF to measure quantities directly on PDF plans.",
      "Track project budgets in real time: purchase orders, expenses and margins in one place.",
    ],
  },
  compta: {
    fr: [
      "La TPS/TVQ se calcule automatiquement sur chaque facture — fini les erreurs de taxes.",
      "Activez l'option PAIE pour payer vos employés CCQ à partir des heures de PUNCH.",
      "Exportez vers QuickBooks, Acomba ou Sage sans ressaisie.",
    ],
    en: [
      "GST/QST is calculated automatically on every invoice — no more tax mistakes.",
      "Enable the PAYROLL add-on to pay CCQ employees straight from PUNCH hours.",
      "Export to QuickBooks, Acomba or Sage with no re-entry.",
    ],
  },
  "devis-ai": {
    fr: [
      "Décrivez le projet : l'IA propose quantités et coûts, vous validez et envoyez en minutes.",
      "Créez des modèles de devis à votre image pour gagner du temps sur chaque soumission.",
      "Convertissez un devis accepté en projet ERP sans tout ressaisir.",
    ],
    en: [
      "Describe the project: AI suggests quantities and costs, you validate and send in minutes.",
      "Create branded quote templates to save time on every submission.",
      "Convert an accepted quote into an ERP project without re-entering everything.",
    ],
  },
  support: {
    fr: [
      "L'assistant IA répond 24/7 — et vous pouvez lui parler à la voix.",
      "Chaque billet reçoit une référence PG-XXXXXX que vous suivez depuis le tableau de bord.",
    ],
    en: [
      "The AI assistant answers 24/7 — and you can even talk to it by voice.",
      "Every ticket gets a PG-XXXXXX reference you can track from your dashboard.",
    ],
  },
};
